export const DEFAULT_TIME_IN_SECONDS_FOR_UPDATE_INTERVAL = 60
